<template>
  <div>
    <div class="page page__list" v-if="!isChange">
      <search-bar
        @search="onSearch"
        name="or_code,or_custname,or_seller"
        placeholder="输入单号、客户、业务员进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/money/othreceivables/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.or_custname}}</p>
            <p class="list-item-muted">{{item.or_code}}</p>
          </div>
          <div class="weui-cell__ft">
            <p v-format="'¥#,##0.00'">{{item.or_amount}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.or_status!='已审核'}"
            >{{item.or_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
        <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('or_amount')}}</em>
      </div>
    </div>
    <div class="page page__list" v-if="isChange">
      <search-bar
        @search="onSearch"
        name="aa_code,cu_name,araccountapply.creatorName"
        placeholder="输入单号、客户、申请人进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/money/araccountapply/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.cu_name}}</p>
            <p class="list-item-muted">{{item.aa_code}}</p>
          </div>
          <div class="weui-cell__ft">
            <p v-format="'¥#,##0.00'">{{item.aa_amount}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.aa_status!='已审核'}"
            >{{item.aa_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
        <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('aa_amount')}}</em>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isChange: false,
      listUrl: "/api/money/othreceivables/list",
      filters: [
        {
          type: "date",
          name: "or_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "or_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "or_statuscode='AUDITED'"
            },
            {
              value: 3,
              label: "待调账"
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isChange = filter.value == 3
      this.listUrl = isChange ? '/api/money/araccountapply/list' : '/api/money/othreceivables/list'
      this.filters[0].name = isChange ? 'aa_date' : 'or_date'
      this.isChange = isChange
      filterBar.initConfig()
      next()
    },
  }
};
</script>